import { useEffect, useState, useContext, useCallback } from "react";
import { ErrorsValue } from "../../../contexts/errors";
import styles from "./styles.module.css";
import { MdWarning } from "react-icons/md";
import { PageValue } from "../../../contexts/page";
import { EditorDisbatch } from "../../../contexts/editor";

export default function Errors() {
  const [open, setOpen] = useState(false);
  const errors = useContext(ErrorsValue);
  const tree = useContext(PageValue);
  const disbatch = useContext(EditorDisbatch);

  const handleElementClick = (error) => {
    let result = {};
    const findBlock = (block, path) => {
      const findIndex = block.children.findIndex((x) => x.id === error.blockId);
      if (findIndex > -1) {
        result = {
          block: block.children[findIndex],
          path: [...path, findIndex],
        };
        return;
      }
      block.children.forEach((child, index) => {
        findBlock(child, [...path, index]);
      });
    };

    findBlock(tree, []);

    console.log(result);
    disbatch({ type: "set", value: result });
  };

  if (errors.elements.length === 0) {
    return null;
  }
  return (
    <div className={styles.errors}>
      <div onClick={() => setOpen(!open)} className={styles.errorHeader}>
        <MdWarning size={24} />
        <div style={{ flexGrow: 1, marginLeft: 12 }}>
          {errors.elements.length} Errors
        </div>
      </div>
      <div
        className={
          open ? styles.errorsList + " " + styles.open : styles.errorsList
        }
      >
        {errors.elements.map((ee) => {
          return (
            <div
              key={ee.blockName + ee.blockerror}
              className={styles.errorItem}
              onClick={() => handleElementClick(ee)}
            >
              <div className={styles.errorTitle}>{ee.blockName}</div>
              <div className={styles.errorDescription}>{ee.blockError}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
